class TestimonialCardsCarousel {
  constructor(container) {
    this.container = container;
    this.carousel = container.querySelector('[data-carousel]');
    this.prevButton = container.querySelector('[data-carousel-prev]');
    this.nextButton = container.querySelector('[data-carousel-next]');

    if (!this.carousel || !this.prevButton || !this.nextButton) return;

    this.cards = Array.from(this.carousel.querySelectorAll('.testimonial-card'));
    this.currentIndex = 0;
    this.cardWidth = 320 + 16; // card width + gap

    this.init();
  }

  init() {
    // Only initialize if navigation is visible (mobile/tablet)
    if (getComputedStyle(this.prevButton.parentElement).display === 'none') {
      return;
    }

    this.updateButtonStates();
    this.bindEvents();
  }

  bindEvents() {
    this.prevButton.addEventListener('click', () => this.scrollToPrev());
    this.nextButton.addEventListener('click', () => this.scrollToNext());

    this.carousel.addEventListener('scroll', () => {
      this.handleScroll();
    });

    // Handle resize to reinitialize if needed
    window.addEventListener('resize', () => {
      setTimeout(() => this.init(), 100);
    });
  }

  scrollToPrev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.scrollToCard(this.currentIndex);
    }
  }

  scrollToNext() {
    if (this.currentIndex < this.cards.length - 1) {
      this.currentIndex++;
      this.scrollToCard(this.currentIndex);
    }
  }

  scrollToCard(index) {
    const scrollLeft = index * this.cardWidth;
    this.carousel.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
    this.updateButtonStates();
  }

  handleScroll() {
    const scrollLeft = this.carousel.scrollLeft;
    const newIndex = Math.round(scrollLeft / this.cardWidth);

    if (newIndex !== this.currentIndex && newIndex >= 0 && newIndex < this.cards.length) {
      this.currentIndex = newIndex;
      this.updateButtonStates();
    }
  }

  updateButtonStates() {
    if (this.prevButton && this.nextButton) {
      this.prevButton.disabled = this.currentIndex === 0;
      this.nextButton.disabled = this.currentIndex >= this.cards.length - 1;
    }
  }
}

// Initialize carousels on page load
document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('.testimonial-cards');
  carousels.forEach(carousel => {
    new TestimonialCardsCarousel(carousel);
  });
});
